import React from 'react';
import { BrainIcon, LeafIcon, HeartIcon, ActivityIcon } from 'lucide-react';
export function WhyItWorks() {
  return <section id="why-it-works" className="w-full py-12 md:py-24 bg-white" data-id="element-248">
      <div className="container px-4 md:px-6 mx-auto" data-id="element-249">
        <div className="text-center mb-12" data-id="element-250">
          <h2 className="text-3xl font-bold tracking-tighter sm:text-4xl md:text-5xl text-gray-900" data-id="element-251">
            Why It Works
          </h2>
          <p className="mx-auto max-w-[700px] text-gray-500 md:text-xl mt-4" data-id="element-252">
            The science behind FocusFlow's effectiveness when coffee fails
          </p>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mt-12" data-id="element-253">
          <div className="bg-gradient-to-br from-sage-50 to-navy-50 p-6 rounded-xl shadow-md flex flex-col items-center text-center" data-id="element-254">
            <div className="h-16 w-16 rounded-full bg-red-100 flex items-center justify-center mb-4" data-id="element-255">
              <ActivityIcon className="h-8 w-8 text-red-600" data-id="element-256" />
            </div>
            <h3 className="text-xl font-bold mb-3" data-id="element-257">Caffeine</h3>
            <p className="text-gray-700" data-id="element-258">Dopamine spike + cortisol crash</p>
            <div className="mt-4 w-full h-1 bg-red-200 rounded-full overflow-hidden" data-id="element-259">
              <div className="h-full w-3/4 bg-red-500 rounded-full animate-pulse" data-id="element-260"></div>
            </div>
          </div>
          <div className="bg-gradient-to-br from-sage-50 to-navy-50 p-6 rounded-xl shadow-md flex flex-col items-center text-center" data-id="element-261">
            <div className="h-16 w-16 rounded-full bg-green-100 flex items-center justify-center mb-4" data-id="element-262">
              <BrainIcon className="h-8 w-8 text-green-600" data-id="element-263" />
            </div>
            <h3 className="text-xl font-bold mb-3" data-id="element-264">Adaptogens</h3>
            <p className="text-gray-700" data-id="element-265">Calm focus + neuroprotection</p>
            <div className="mt-4 w-full h-1 bg-green-200 rounded-full overflow-hidden" data-id="element-266">
              <div className="h-full w-full bg-green-500 rounded-full" data-id="element-267"></div>
            </div>
          </div>
          <div className="bg-gradient-to-br from-sage-50 to-navy-50 p-6 rounded-xl shadow-md flex flex-col items-center text-center" data-id="element-268">
            <div className="h-16 w-16 rounded-full bg-amber-100 flex items-center justify-center mb-4" data-id="element-269">
              <HeartIcon className="h-8 w-8 text-amber-600" data-id="element-270" />
            </div>
            <h3 className="text-xl font-bold mb-3" data-id="element-271">Cacao</h3>
            <p className="text-gray-700" data-id="element-272">Mood + magnesium</p>
            <div className="mt-4 w-full h-1 bg-amber-200 rounded-full overflow-hidden" data-id="element-273">
              <div className="h-full w-full bg-amber-500 rounded-full" data-id="element-274"></div>
            </div>
          </div>
          <div className="bg-gradient-to-br from-sage-50 to-navy-50 p-6 rounded-xl shadow-md flex flex-col items-center text-center" data-id="element-275">
            <div className="h-16 w-16 rounded-full bg-blue-100 flex items-center justify-center mb-4" data-id="element-276">
              <LeafIcon className="h-8 w-8 text-blue-600" data-id="element-277" />
            </div>
            <h3 className="text-xl font-bold mb-3" data-id="element-278">Herbs</h3>
            <p className="text-gray-700" data-id="element-279">Anti-inflammatory + gut balancing</p>
            <div className="mt-4 w-full h-1 bg-blue-200 rounded-full overflow-hidden" data-id="element-280">
              <div className="h-full w-full bg-blue-500 rounded-full" data-id="element-281"></div>
            </div>
          </div>
        </div>
        <div className="mt-12 text-center" data-id="element-282">
          <p className="text-lg font-medium text-sage-600" data-id="element-283">
            The difference isn't just what you feel today—it's how you perform
            tomorrow.
          </p>
        </div>
      </div>
    </section>;
}